module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	'use strict';

	fox.registerWidget('DesktopNotifications', {
		configure: function (argument) {

			this.registerOptions('', {
				focusPageOnClick: true,
				onlyInInactiveWindow: false,
				defaultIcon: [fox.getEnv('design.path'), 'images/star.png'].join('/'),
				defaultTimeout: 5
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.notifyAPI = window.Notify;
			this.defaultIcon = this.getOption('defaultIcon');
			this.defaultTimeout = this.getOption('defaultTimeout');

			/*
				icon: '',
	            body: '',
	            tag: '',
	            notifyShow: null,
	            notifyClose: null,
	            notifyClick: null,
	            notifyError: null,
	            timeout: null
			*/

			this.callParent('init', arguments);
		},

		focus: function (argument) {
			window.focus();
		},

		push: function (title, data, onlyInInactiveWindow) {
			if ( this.notifyAPI && this.notifyAPI.needsPermission) {
				this.notifyAPI.requestPermission(fox.bind(function () {
					this.push(title, data);
				}, this));

				return;
			}

			if (fox.isSet(onlyInInactiveWindow) && onlyInInactiveWindow === true) {
				this.showIfInactiveWindow(title, this.mergeParams(data));

				return;
			}

			if (this.getOption('onlyInInactiveWindow')) {
				this.showIfInactiveWindow(title, this.mergeParams(data));

				return;
			}

			this.show(title, this.mergeParams(data));
		},

		mergeParams: function (data) {
			var params = {};

			fox.isObject(data) || (data = {});

			if (!data.icon) {
				params.icon = this.defaultIcon;
			}

			params.icon = data.icon || this.defaultIcon;
			params.timeout = data.timeout || this.defaultTimeout;

			if (data.body) {
				params.body = data.body;			
			}

			params.notifyClick = fox.bind(function () {
				if (this.getOption('focusPageOnClick')) {
					this.focus();
				}

				if (fox.isFunction(data.notifyClick)) {
					data.notifyClick();
				}
			}, this);

			params.notifyShow = fox.bind(function () {
				if (fox.isFunction(data.notifyShow)) {
					data.notifyShow();
				}
			}, this);
			params.notifyClose = fox.bind(function () {
				if (fox.isFunction(data.notifyClose)) {
					data.notifyClose();
				}
			}, this);
			params.notifyError = fox.bind(function () {
				if (fox.isFunction(data.notifyError)) {
					data.notifyError();
				}
			}, this);

			return params;
		},

		showIfInactiveWindow: function (title, data) {
			if (!fox.dom.documentHasFocus()) {
				this.show(title, data);
			}
		},

		show: function (title, params) {
			if (!window.Notify) return false;

			return new window.Notify(title, params).show();
		},

	}, 'Controller');
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/desktopNotifications.js
// module id = 185
// module chunks = 0